let artigosRelacionados = ( () => {

    let public = () => {
        let artigos_rel = new Swiper("#artigos-relactionados #artigos-swiper", {
            slidesPerView: 3,
            spaceBetween: 23,
            breakpoints: {
              320: {
                slidesPerView: 1,
                spaceBetween: 23,
                pagination: {
                  el: ".pagi_artigos",
                  type: "bullets",
                },
              },
              480: {
                slidesPerView: 2,
                spaceBetween: 23,
                pagination: {
                  el: ".pagi_artigos",
                  type: "bullets",
                },
              },
              992: {
                slidesPerView: 3,
                spaceBetween: 23,
              },
            },
          });
    }

    let init = () => {
        public();
    }

    return {
       initArtigosRelacionados: init
    };

})();
$(document).ready(artigosRelacionados.initArtigosRelacionados);